import PropTypes from "prop-types";

import { DocumentType } from "@/propTypes";

export const DefaultTemplateType = {
  id: PropTypes.number,
  name: PropTypes.string,
  state: PropTypes.string,
  version: PropTypes.number,
};

export const ModelType = {
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  address: PropTypes.string,
  logo_document: DocumentType,
  intervention_template_id: PropTypes.number,
  default_template: PropTypes.shape(DefaultTemplateType),
};

export const InitialValuesType = {
  name: PropTypes.string,
  description: PropTypes.string,
  address: PropTypes.string,
  template: PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ]),
};
